import React, { useEffect, useState, useContext } from 'react'
import styles from './Identificacion.module.css'
import * as Funciones from '../../utils/funciones'
import CardPhoto from './components/cardPhoto'
import RenderPersona from './components/renderPersona'
import RenderEmpresa from './components/renderEmpresa'
import caraPosterior from '../../img/cara-posterior.png'
import caraFrontal from '../../img/cara-frontal.png'
import GeneralContext from '../../context/GeneralContext'
import Subtitle from '../Subtitle'
import * as GeneralActions from "../../store/actions/generalActions";
import * as GeneralRepository from "../../services/repositories/general-repository";
import ModalValidacionPersonas from '../ModalValidacionPersonas/ModalValidacionPersonas'

const Identificacion = ({ asegurado, contratante, state, setState, mostrarPopup }) => {
    const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
    const [documentos, setDocumentos] = useState([])
    const [isMobile, setMobile] = useState(false)
    const [openModal, setOpenModal] = useState(false)

    const handleBurPersonID = async () => {
        const buscarPersonID = async () => {
            const response = await GeneralRepository.obtenerValidacionPersonas(state.contratante.tipoDocumento.codigo, 
                state.contratante.numeroDocumento)
            if(response.error === null) {
                if (response.personas.length === 1) {
                    let persona = response.personas[0]
                    let contratanteAux = {
                        tipoDocumento: state.contratante.tipoDocumento,
                        numeroDocumento: state.contratante.numeroDocumento,
                        tipoPersona: {
                            codigo: state.contratante.tipoPersona.codigo
                        },
                        idSolicitudMultiple: state.contratante.idSolicitudMultiple,
                        laboral: null,
                        nombres: Funciones.mostrarCamelCase(persona.nombres),
                        apellidoPaterno: Funciones.mostrarCamelCase(persona.apellidoPaterno),
                        apellidoMaterno: Funciones.mostrarCamelCase(persona.apellidoMaterno),
                        fechaNacimiento: Funciones.formatearTextoAFecha(persona.fechaNacimiento),
                        sexo: {
                            codigo: persona.sexo === 'F' ? 0 : persona.sexo === 'M' ? 1 : null
                        },
                        indicadorModificacionDatosPID: '1',
                        idContratante: state.contratante.idContratante !== undefined && state.contratante.idContratante !== null &&
                            state.contratante.idContratante !== 0 ? state.contratante.idContratante : undefined,
                        subRespuestas: []
                    }
    
                    setState((state) => {
                        return {
                            ...state,
                            contratante: contratanteAux,
                            campoValidado: {
                                ...state.campoValidado,
                                nombres: true,
                                apellidoPaterno: true,
                                apellidoMaterno: true,
                                sexo: true,
                                fechaNacimiento: true
                            }
                        }
                    })
                } else if (response.personas.length === 2) {
                    let viap = response.personas.find(p => p.origen === 'viap')
                    let personID = response.personas.find(p => p.origen === 'personid')
                    
                    setState((state) => {
                        return {
                            ...state,
                            viap: viap,
                            personID: personID
                        }
                    })

                    setOpenModal(true)
                } else {
                    generalDispatch(GeneralActions.updateError(
                        {mensajeRespuesta: 'El identificador de personas no identificó ningún dato para el documento consultado'}, '¡Mensaje!')
                    )
                    setState((state) => {
                        return {
                            ...state,
                            contratante: {
                                tipoDocumento: state.contratante.tipoDocumento,
                                numeroDocumento: state.contratante.numeroDocumento,
                                tipoPersona: {
                                    codigo: state.contratante.tipoPersona.codigo
                                },
                                idSolicitudMultiple: state.contratante.idSolicitudMultiple,
                                laboral: null,
                                indicadorModificacionDatosPID: '3',
                                subRespuestas: []
                            }
                        }
                    })
                }
            } else {
                setState((state) => {
                    return {
                        ...state,
                        contratante: {
                            tipoDocumento: state.contratante.tipoDocumento,
                            numeroDocumento: state.contratante.numeroDocumento,
                            tipoPersona: {
                                codigo: state.contratante.tipoPersona.codigo
                            },
                            idSolicitudMultiple: state.contratante.idSolicitudMultiple,
                            laboral: null,
                            indicadorModificacionDatosPID: '3',
                            subRespuestas: []
                        }
                    }
                })
                generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
            }
        }

        if (state.contratante.tipoDocumento && state.contratante.tipoDocumento.codigo !== undefined &&
            state.contratante.tipoDocumento.codigo !== null && state.contratante.tipoDocumento.codigo !== -1 &&
            state.contratante.tipoDocumento.codigo !== 0 && state.contratante.numeroDocumento) {
            if (state.contratante.tipoDocumento.codigo === 1) {
                if (state.contratante.numeroDocumento.length < 8) {
                    generalDispatch(GeneralActions.updateError(
                        {mensajeRespuesta: 'La longitud del documento no debe ser menor que 8.'}, '¡Alerta!')
                    )
                } else {
                    generalDispatch(GeneralActions.updateEstadoCargando(true))
                    await buscarPersonID()
                    generalDispatch(GeneralActions.updateEstadoCargando(false))
                }
            } else if (state.contratante.tipoDocumento.codigo === 3) {
                if (state.contratante.numeroDocumento.length < 8) {
                    generalDispatch(GeneralActions.updateError(
                        {mensajeRespuesta: 'La longitud del documento debe estar entre 8 y 12.'}, '¡Alerta!')
                    )
                } else {
                    generalDispatch(GeneralActions.updateEstadoCargando(true))
                    await buscarPersonID()
                    generalDispatch(GeneralActions.updateEstadoCargando(false))
                }
            }    
        } 
    }

    const personaSeleccionada = (valor) => {
        let persona = valor === 1 ? state.personID : state.viap
        let contratanteAux = {
            tipoDocumento: state.contratante.tipoDocumento,
            numeroDocumento: state.contratante.numeroDocumento,
            tipoPersona: {
                codigo: state.contratante.tipoPersona.codigo
            },
            idSolicitudMultiple: state.contratante.idSolicitudMultiple,
            laboral: null,
            nombres: Funciones.mostrarCamelCase(persona.nombres),
            apellidoPaterno: Funciones.mostrarCamelCase(persona.apellidoPaterno),
            apellidoMaterno: Funciones.mostrarCamelCase(persona.apellidoMaterno),
            fechaNacimiento: Funciones.formatearTextoAFecha(persona.fechaNacimiento),
            sexo: {
                codigo: persona.sexo === 'F' ? 0 : persona.sexo === 'M' ? 1 : null
            },
            indicadorModificacionDatosPID: '1',
            idContratante: state.contratante.idContratante !== undefined && state.contratante.idContratante !== null &&
                state.contratante.idContratante !== 0 ? state.contratante.idContratante : undefined,
            subRespuestas: []
        }
        setState((state) => {
            return {
                ...state,
                contratante: contratanteAux,
                campoValidado: {
                    ...state.campoValidado,
                    nombres: true,
                    apellidoPaterno: true,
                    apellidoMaterno: true,
                    sexo: true,
                    fechaNacimiento: true
                }
            }
        })

        setOpenModal(false)
    }

    const handleChangeCombo = (event, campo) => {
        let codigo = event.target.value
        let descripcion = event.target[event.target.selectedIndex].text
        if ((contratante && contratante.tipoPersona && contratante.tipoPersona.codigo === 1)) {
            setState((state) => {
                return {
                    ...state,
                    contratante: {
                        ...contratante,
                        [campo]: {
                            codigo: parseInt(codigo),
                            descripcion: descripcion
                        },
                        numeroDocumento: ''
                    },
                    campoValidado: {
                        ...state.campoValidado,
                        [campo]: true
                    }
                }
            })
        } else if ((contratante && contratante.tipoPersona && contratante.tipoPersona.codigo === 2)) {
            setState((state) => {
                return {
                    ...state,
                    contratante: {
                        ...contratante,
                        representanteLegal: {
                            ...state.contratante.representanteLegal,
                            [campo]: {
                                codigo: parseInt(codigo),
                                descripcion: descripcion
                            },
                            numeroDocumento: ''
                        }
                    },
                    campoValidado: {
                        ...state.campoValidado,
                        tipoDocumentoRL: true
                    }
                }
            })
        }

    }

    const handleChangeNumerico = (e, campo, codigo) => {
        let valor = ''
        switch (codigo) {
            case 1:
                valor = e.target.value.replace(/[^0-9 \u00f1\u00d1]/gi, "")
                break;
            case 3:
                valor = e.target.value.replace(/[^0-9A-Z]/gi, "")
                valor = valor.toUpperCase()
                break;
            case 4:
                valor = e.target.value.replace(/[^0-9 \u00f1\u00d1]/gi, "")
                break;
            default:
                console.error('No existe un Tipo de documento válido')
        }
        setState((state) => {
            return {
                ...state,
                contratante: {
                    ...contratante,
                    [campo]: valor
                },
                campoValidado: {
                    ...state.campoValidado,
                    [campo]: true
                }
            }
        })
    }

    useEffect(() => {
        /**
         * Valido si es un dispositivo mobile, por defecto los dispositivos
         * móviles tienen orientación(landscape, portrait) entonces condiciono
         * si tiene la propiedad orientación en el navegador es un mobile
         */
        if (typeof window.orientation !== 'undefined') {
            setMobile(true)
        }

        setDocumentos(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 13))
    }, [])


    /**
     * Función que renderiza un formulario para completar datos según su tipo (persona, empresa)
     */
    const renderContenidoTipoPersona = () => {
        let contenidoTipoPersona = ''

        if ((contratante && contratante.tipoPersona && contratante.tipoPersona.codigo === 1)) {
            contenidoTipoPersona = (
                <RenderPersona
                    state={state}
                    asegurado={asegurado}
                    contratante={contratante}
                    documentos={documentos.filter(doc => { return doc.id === 1 || doc.id === 3 })}
                    handleChangeNumerico={handleChangeNumerico}
                    handleChangeCombo={handleChangeCombo}
                    handleChangeBlur={handleBurPersonID}
                />
            )
        } else if ((contratante && contratante.tipoPersona && contratante.tipoPersona.codigo === 2)) {
            contenidoTipoPersona = (
                <RenderEmpresa
                    state={state}
                    asegurado={asegurado}
                    contratante={contratante}
                    documentos={documentos.filter(doc => { return doc.id === 1 || doc.id === 3 })}
                    handleChangeCombo={handleChangeCombo}
                />
            )
        }

        return contenidoTipoPersona
    }

    const optionalChainingContratante = contratante && contratante.tipoPersona !== undefined
        && (contratante.tipoPersona.codigo === 1 || contratante.tipoPersona.codigo === 2)
    const typeIdentification = optionalChainingContratante ? 'contratante' : 'asegurado'

    return (
        <React.Fragment>
            {openModal && 
                <ModalValidacionPersonas 
                    viap={state.viap}
                    personID={state.personID}
                    accion={personaSeleccionada}
                />
            }
            <div className={styles['areaprospectocard1']}>
                {
                    state.esAseguradoAdicional ?
                        <Subtitle
                            sname={'Identificación del Asegurado Principal'}
                        />
                    :
                        <Subtitle
                            sname={asegurado ? 'Identificación del Asegurado' : contratante ? 'Identificación del Contratante' : 'Identificación'}
                        />
                }

                {renderContenidoTipoPersona()}

            </div>
        </React.Fragment>
    )
}

export default Identificacion
